import { Record } from 'immutable';
const ImportedArticleNeedsReviewRecord = Record({
  error: undefined,
  isRequesting: false,
  needsReview: undefined,
  lastLoaded: null
});
export default ImportedArticleNeedsReviewRecord;